import React, { Component } from 'react';
import { TableForm } from 'components/Commons';
import { connect } from 'react-redux';
import { Grid, Header, Label, Segment, Tab } from 'semantic-ui-react';
import TradingResult from 'components/SettlementList/SidePage/TradingResult';
import moment from 'moment';
import Constants from 'components/SettlementList/Constants';
import ExcelDownButton from 'components/SettlementList/SidePage/SubPage/ExcelDownButton';

import numeral from 'numeral';

class Trading extends Component {
  renderApprovalLabel = (data) => {
    let approvalLabel;

    if (data === Constants.TRADING_APPROVAL_STATUS.READY) {
      approvalLabel = (
        <Label size="large" color="black" ribbon>
          요청 대기중인 거래명세서입니다.
        </Label>
      );
    } else if (data === Constants.TRADING_APPROVAL_STATUS.COMPLETE) {
      approvalLabel = (
        <Label size="large" color="green" ribbon>
          승인된 거래명세서입니다.
        </Label>
      );
    } else if (data === Constants.TRADING_APPROVAL_STATUS.REJECT) {
      approvalLabel = (
        <Label size="large" color="red" ribbon>
          반려된 거래명세서입니다.
        </Label>
      );
    }

    return approvalLabel;
  };

  renderCompanyApplyStoreTable = (data) => {
    const companyApplyStoreTable = {
      header: {
        main: [
          { data: '제휴점', textAlign: 'center' },
          { data: '정산방식', textAlign: 'center' },
          { data: '과세유형', textAlign: 'center' },
          { data: '식대총합', textAlign: 'center' }
        ]
      },
      body: {
        message: '작성 내역이 존재하지 않습니다.',
        main: null
      }
    };

    companyApplyStoreTable.body.main = data.map((item) => {
      const obj = {
        row: [
          {
            data: item.storeName,
            textAlign: 'center'
          },
          {
            data: item.settleTypeName,
            textAlign: 'center'
          },
          {
            data: item.taxationTypeName,
            textAlign: 'center'
          },
          {
            data: numeral(item.mealAmt).format('0,0'),
            textAlign: 'right'
          }
        ]
      };

      return obj;
    });

    return <TableForm selectable="true" tabledata={companyApplyStoreTable} />;
  };

  render() {
    const { tradingInfo, stepProgress, bankData } = this.props;

    let companyApplyStoreTable;
    let tradingTitle;
    let approvalLabel;

    if (tradingInfo && tradingInfo.data && stepProgress && stepProgress.data && bankData && bankData.data) {
      const { companyApplyStoreList, companyTrading } = tradingInfo.data;

      approvalLabel = this.renderApprovalLabel(companyTrading.approvalTypeCode);

      tradingTitle = `${moment(companyTrading.taxInvoiceYmd).format('YYYY년 MM월')} 거래명세서`;
      companyApplyStoreTable = this.renderCompanyApplyStoreTable(companyApplyStoreList);
    }

    return (
      <div>
        <Tab.Pane style={{ width: 'unset', border: 'none' }}>
          <Grid>
            <Grid.Row style={{ paddingTop: '0px' }}>
              <Grid.Column style={{ paddingLeft: '0px', paddingRight: '0px' }}>
                <Segment>
                  <Grid.Row>
                    <Grid>
                      <Grid.Row>
                        <Grid.Column width="6">{approvalLabel}</Grid.Column>
                        <Grid.Column width="7">
                          <Header as="h3" textAlign="left" style={{ marginTop: '5px' }}>
                            {tradingTitle}
                          </Header>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <TradingResult />
                    </Grid.Column>
                  </Grid.Row>
                </Segment>
                <Segment>
                  <Grid.Row>
                    <Grid.Column>
                      <Header as="h3" textAlign="center">
                        제휴식당 정산내역
                      </Header>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <div style={{ marginTop: '20px' }}>{companyApplyStoreTable}</div>
                  </Grid.Row>
                </Segment>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Tab.Pane>
        <ExcelDownButton />
      </div>
    );
  }
}

Trading = connect((state) => ({
  bankData: state.settlement.bankDepositDetail,
  tradingInfo: state.settlement.tradingInfo,
  stepProgress: state.settlement.progressStatus
}))(Trading);

export default Trading;
